import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker, HiOutlineArrowRight } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";

export default function ContactUsContent() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const message = formData.get('message');
    
    const subject = `Partnership Inquiry from ${name}`;
    const body = `Name: ${name}%0D%0AEmail: ${email}%0D%0A%0D%0AMessage:%0D%0A${message}`;
    
    // Launches the default mailing app with pre-filled data
    window.location.href = `mailto:info@mirabel.com?subject=${encodeURIComponent(subject)}&body=${body}`;
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700;800&display=swap');
        
        :root { 
          --sunflower-amber: #BC9132; 
          --text-navy: #012243; 
          --text-slate: #475569; 
          --bg-light: #F8FAFC; 
          --border-subtle: #E2E8F0; 
          --font-corporate: 'Libre Franklin', sans-serif; 
        }

        .contact-viewport { 
          padding: 100px 0; 
          background: var(--bg-light); 
          font-family: var(--font-corporate); 
          position: relative;
          overflow: hidden;
        }

        /* Decorative background glow */
        .contact-viewport::before {
          content: '';
          position: absolute;
          top: -150px;
          right: -150px;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(188, 145, 50, 0.06) 0%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }

        .contact-container { 
          max-width: 1280px; 
          margin: 0 auto; 
          padding: 0 24px; 
          position: relative;
          z-index: 2;
        }

        .contact-header { 
          text-align: center; 
          margin-bottom: 60px; 
        }

        .contact-header h2 { 
          font-size: clamp(2rem, 4vw, 2.8rem); 
          color: var(--text-navy); 
          font-weight: 800; 
          letter-spacing: -0.02em; 
          margin-bottom: 16px; 
        }

        .contact-header h2 .italic {
          font-style: italic;
          font-weight: 300;
          color: var(--sunflower-amber);
        }

        .contact-header p { 
          color: var(--text-slate); 
          font-size: 1.1rem; 
          max-width: 600px; 
          margin: 0 auto; 
          line-height: 1.6;
        }

        .contact-grid { 
          display: grid; 
          grid-template-columns: 1fr 1.2fr; 
          gap: 60px; 
          align-items: start;
        }

        /* --- LEFT COLUMN: IMAGE & INFO CARDS --- */
        .contact-left-col {
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .contact-image-block {
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          aspect-ratio: 16/10;
          box-shadow: 0 25px 50px -15px rgba(0,0,0,0.15);
        }

        .contact-image-block img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .contact-image-block:hover img {
          transform: scale(1.08);
        }

        .contact-image-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, transparent 30%, rgba(10, 15, 28, 0.9) 100%);
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 32px;
          color: #fff;
        }

        .contact-image-overlay h4 {
          font-size: 1.6rem;
          font-weight: 800;
          margin: 0 0 8px;
          letter-spacing: -0.01em;
        }

        .contact-image-overlay p {
          font-size: 0.95rem;
          margin: 0;
          color: rgba(255,255,255,0.8);
          max-width: 80%;
        }

        /* Info Cards Grid */
        .contact-info-cards { 
          display: grid; 
          grid-template-columns: 1fr 1fr; 
          gap: 20px; 
        }

        .info-card { 
          background: #fff; 
          border: 1px solid var(--border-subtle); 
          border-radius: 16px; 
          padding: 24px; 
          display: flex; 
          flex-direction: column;
          gap: 16px;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1); 
          text-decoration: none;
          color: inherit;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        /* Top accent bar animation */
        .info-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 3px;
          background: var(--sunflower-amber);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .info-card:hover::before {
          transform: scaleX(1);
        }

        .info-card:hover { 
          transform: translateY(-6px);
          border-color: transparent;
          box-shadow: 0 20px 40px -15px rgba(188, 145, 50, 0.2); 
        }

        .info-icon { 
          width: 48px; 
          height: 48px; 
          border-radius: 12px; 
          background: rgba(188, 145, 50, 0.1); 
          color: var(--sunflower-amber); 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          font-size: 1.3rem; 
          transition: all 0.4s ease;
        }

        .info-card:hover .info-icon {
          background: var(--sunflower-amber);
          color: #fff;
          transform: rotate(-5deg) scale(1.05);
        }

        .info-text h4 { 
          color: var(--text-navy); 
          font-size: 1rem; 
          font-weight: 700; 
          margin: 0; 
        }

        .info-text span { 
          color: var(--text-slate); 
          font-size: 0.85rem; 
          line-height: 1.5; 
          margin: 0; 
          display: block;
        }

        /* --- RIGHT COLUMN: FORM --- */
        .contact-form-wrap { 
          background: #fff; 
          border: 1px solid var(--border-subtle); 
          border-radius: 24px; 
          padding: 48px; 
          box-shadow: 0 25px 60px -20px rgba(0,0,0,0.08); 
          position: relative;
        }

        /* Floating badge using imported image */
        .form-badge {
          position: absolute;
          top: -20px;
          right: 40px;
          background: #fff;
          border-radius: 100px;
          padding: 8px 20px 8px 8px;
          display: flex;
          align-items: center;
          gap: 12px;
          box-shadow: 0 10px 30px -10px rgba(0,0,0,0.15);
          border: 1px solid var(--border-subtle);
          z-index: 5;
        }
        .form-badge img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
        }
        .form-badge span {
          font-size: 0.8rem;
          font-weight: 700;
          color: var(--text-navy);
        }

        .contact-form-wrap h3 { 
          color: var(--text-navy); 
          font-size: 1.8rem; 
          font-weight: 800; 
          margin: 0 0 12px; 
          letter-spacing: -0.02em; 
        }

        .contact-form-wrap > p {
          color: var(--text-slate);
          font-size: 0.95rem;
          margin: 0 0 32px;
        }

        .form-group { 
          margin-bottom: 24px; 
          position: relative;
        }

        .form-group label { 
          display: block; 
          color: var(--text-navy); 
          font-size: 0.8rem; 
          font-weight: 600; 
          margin-bottom: 8px; 
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .form-group input, .form-group textarea { 
          width: 100%; 
          padding: 16px 20px; 
          border: 1px solid var(--border-subtle); 
          border-radius: 12px; 
          font-family: var(--font-corporate); 
          font-size: 0.95rem; 
          color: var(--text-navy); 
          background: var(--bg-light); 
          transition: all 0.3s ease; 
          outline: none; 
          box-sizing: border-box; 
        }

        .form-group input:focus, .form-group textarea:focus { 
          border-color: var(--sunflower-amber); 
          background: #fff; 
          box-shadow: 0 0 0 4px rgba(188, 145, 50, 0.1); 
        }

        .form-group textarea { 
          min-height: 140px; 
          resize: vertical; 
        }

        .btn-submit { 
          width: 100%; 
          padding: 18px; 
          background: var(--text-navy); 
          color: #fff; 
          border: none; 
          border-radius: 12px; 
          font-family: var(--font-corporate); 
          font-size: 0.9rem; 
          font-weight: 700; 
          text-transform: uppercase; 
          letter-spacing: 0.08em; 
          cursor: pointer; 
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1); 
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        /* Sliding background effect */
        .btn-submit::before {
          content: '';
          position: absolute;
          inset: 0;
          background: var(--sunflower-amber);
          transform: translateX(-100%);
          transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
          z-index: 0;
        }

        .btn-submit:hover::before {
          transform: translateX(0);
        }

        .btn-submit span, .btn-submit svg {
          position: relative;
          z-index: 1;
        }

        .btn-submit:hover { 
          color: var(--text-navy);
          transform: translateY(-2px); 
          box-shadow: 0 15px 30px rgba(188, 145, 50, 0.3); 
        }

        /* --- RESPONSIVE --- */
        @media (max-width: 992px) { 
          .contact-grid { grid-template-columns: 1fr; gap: 40px; } 
          .contact-form-wrap { padding: 32px; } 
          .form-badge { right: 20px; top: -15px; }
        }

        @media (max-width: 600px) { 
          .contact-info-cards { grid-template-columns: 1fr; } 
          .contact-form-wrap { padding: 24px; }
          .contact-image-overlay { padding: 24px; }
          .contact-image-overlay h4 { font-size: 1.3rem; }
        }
      `}</style>

      <section className="contact-viewport">
        <div className="contact-container">
          <div className="contact-header">
            <h2>Get In <span className="italic">Touch</span></h2>
            <p>Connect with Mirabel Suites for reservations, partnerships, property management, and travel support.</p>
          </div>

          <div className="contact-grid">
            {/* LEFT COLUMN */}
            <div className="contact-left-col">
              <div className="contact-image-block">
                <img src={banner1} alt="Sunflower Ecosystem" />
                <div className="contact-image-overlay">
                  <h4>Partner With Us</h4>
                  <p>Let us manage great stays, warm guest support, and reliable hospitality services.</p>
                </div>
              </div>

              <div className="contact-info-cards">
                <a href="https://www.google.com/maps/search/?api=1&query=P.O.Box+15404+Arusha+Tanzania" target="_blank" rel="noreferrer" className="info-card">
                  <div className="info-icon"><HiOutlineLocationMarker /></div>
                  <div className="info-text">
                    <h4>Head Office</h4>
                    <span>P.O.Box 15404</span>
                    <span>Arusha, Tanzania</span>
                  </div>
                </a>
                
                <a href="mailto:info@mirabel.com" className="info-card">
                  <div className="info-icon"><HiOutlineMail /></div>
                  <div className="info-text">
                    <h4>Email Us</h4>
                    <span>info@mirabelsuites.com</span>
                    <span>md@mirabelsuites.com</span>
                  </div>
                </a>

                <a href="tel:+255784946604" className="info-card">
                  <div className="info-icon"><HiOutlinePhone /></div>
                  <div className="info-text">
                    <h4>Call Us</h4>
                    <span>+255 784 946 604</span>
                  </div>
                </a>

                <a href="https://wa.me/255784946604" target="_blank" rel="noreferrer" className="info-card">
                  <div className="info-icon"><FaWhatsapp /></div>
                  <div className="info-text">
                    <h4>WhatsApp</h4>
                    <span>Quick guest support</span>
                    <span>Mirabel Suites</span>
                  </div>
                </a>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="contact-form-wrap">
              <div className="form-badge">
                <img src={banner2} alt="Mirabel Suites" />
                <span>Guest Support</span>
              </div>
              
              <h3>Send an Inquiry</h3>
              <p>Fill out the form below and your default email app will open with your message pre-filled.</p>
              
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Full Name</label>
                  <input type="text" name="name" required />
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" name="email" required />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea name="message" placeholder="How can we help with your stay, partnership, or property?" required></textarea>
                </div>
                <button type="submit" className="btn-submit">
                  <span>Launch Email App</span>
                  <HiOutlineArrowRight size={18} />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
